<script>
  import UserAvatar from '../../lib/components/UserAvatar.svelte';
  import { t9n } from '../../lib/translate';
  import { TS } from '../../config/translation-keys';
  import session from '../../lib/session';

  // component options  ------------------------------------------------------ //

  export let profile;
</script>

<table class={`table user-header ${profile.role}`} style="order: -1;">
  <tbody>
    <tr>
      <td class="animated bounceInLeft">

      </td>

      <td class="person-info" colspan="2">
        <div class="profile-link" href="/public-profile" style="position:relative;">

          <span class="img-container">
            <UserAvatar
              url={profile.profile_image_url}
              options={{ class: 'slideInLeft', style: 'width: 80px ;height: 80px; border-radius: 50%; margin-top: 0.6em;' }} />

            {#if !!profile._user && !!profile._user.age_range}
              {#if profile._user.age_range !== "age_range_under_15" && profile._user.age_range !== "age_range_15_17"}
                <span class:hide={(profile.role === 'orderer' && $session.user.last_role === 'worker') || (profile.role === 'orderer' && $session.user.last_role === 'orderer')} class="circle-under-15">{t9n(TS.LABEL_OVER_18)}</span>
              {/if}
              {#if profile._user.age_range === "age_range_under_15"}
                <span class:hide={(profile.role === 'orderer' && $session.user.last_role === 'worker') || (profile.role === 'orderer' && $session.user.last_role === 'orderer')} class="circle-under-15">{t9n(profile._user.age_range)}</span>
              {/if}
            {/if}
          </span>

          <h4 class="user-name slideInRight">{profile.display_name}</h4>

<!--          <div class="user-info slideUp">{profile.header_role_text}</div>-->

          {#if profile.unread_chat_messages_count > 0}
            <!-- chat message counter -->
            <a class="chat-link slideUp">
              <img src="/assets/messages/message-text.png" alt="chat" />
              <span class="badge chat-counter">{profile.unread_chat_messages_count}</span>
            </a>
          {/if}
        </div>
      </td>

      <td class="animated bounceInRight">

      </td>
    </tr>
  </tbody>
</table>

<style>
    .hide{
        display: none;
    }
  .user-name {
    text-transform: uppercase;
    font-weight: 500;
    margin-bottom: 0;
    margin-top: 5px;
  }

  .user-counters {
    font-size: 25px;
    margin-bottom: 1px;
  }

  .user-info {
    font-size: 14px;
    display: inline-block;
  }

  .profile-link {
    text-decoration: none;
  }

  .chat-link {
    line-height: 4em;
    display: inline-block;
    text-align: center;
    width: 100%;
    text-decoration: none;
    overflow: hidden;
    margin-bottom: -3em;
  }

  .chat-counter {
    display: inline-block;
    vertical-align: top;
    margin-left: -1em;
    margin-top: 0.5em;
    border: 2px solid white;
  }

  .badge {
    background: #ff6c60;
    font-size: 10px;
    font-weight: normal;
    line-height: 13px;
    padding: 2px 5px;
    position: relative;
    right: 4px;
    top: 1px;
    border-radius: 10px;
    /*-webkit-border-radius: 2px;*/
  }

  .table {
    width: 100%;
    /*margin-bottom: 10px;*/
    border-collapse: collapse;
    table-layout: fixed;
    border-radius: 5px;
    /*border-top-left-radius: 10px;*/
    /*border-top-right-radius: 10px;*/
  }

  .orderer {
    background-color: var(--orderer-background-color);
    -webkit-box-shadow: 1px 1px 15px 0px rgba(0, 0, 0, 0.1);
    -moz-box-shadow: 1px 1px 15px 0px rgba(0, 0, 0, 0.1);
    box-shadow: 1px 1px 15px 0px rgba(0, 0, 0, 0.1);
  }

  .worker {
    background-color: var(--worker-background-color);
    -webkit-box-shadow: 1px 1px 15px 0px rgba(0, 0, 0, 0.1);
    -moz-box-shadow: 1px 1px 15px 0px rgba(0, 0, 0, 0.1);
    box-shadow: 1px 1px 15px 0px rgba(0, 0, 0, 0.1);
  }

  .user-header {
    color: white;
    font-size: 14px;
    text-align: center;
  }

  .person-info {
    padding: 1em 0 2em;
  }

  .circle-age-18 {
    position: absolute;
    height: 22px;
    width: 22px;
    background-color: #21adbb;
    border-radius: 50%;
    color: white;
    /*padding: 2px;*/
    border: 1px solid white;
    /*color: black;*/
    /*color: #006699;*/
    right: 200px;
    font-weight: 800;
    font-size: 12px;
    padding-top: 10px;
    padding-left: 5px;
    padding-right: 5px;
  }

  .circle-under-15{
      position: absolute;
      color: white;
      border: 1px solid white;
      background-color: #21adbb;
      font-weight: 800;
      font-size: 12px;

      height: 14px;
      width: fit-content;
      border-radius: 5px;
      left: 0;
      bottom: 21px;
      right: 0;
      margin: auto;
      padding: 4px;
  }
</style>
